import { ControlUser } from './controlUser';
import { Deserializable } from './deserializable';


export class UserOwnerRelData implements Deserializable {

  name: string;
  description : string;
  groupId: number;
  groupName : string;

  deserialize(input: any) {

    Object.assign(this, input);

    return this;
  }
}
